module.exports = __webpack_public_path__ + "static/images/completed._UUF9To.svg";